(function () {
    "use strict";

    /*global angular*/
    var app = angular.module('cccu.photoUpload.success', ['ui.router']);

    app.config(function ($stateProvider) {
        $stateProvider.state('success', {
            url: '/success',
            views: {
                "main": {
                    controller: 'SuccessController',
                    templateUrl: 'success/index.html'
                }
            },
            data: {
                pageTitle: 'Success'
            }
        });
    });

    app.controller('SuccessController', ['$scope', '$location', '$log', function ($scope, $window) {
        var campusM = window.parent.CampusM;

        $scope.showNext = (campusM) ? true : false;

        $scope.next = function () {
            campusM.Modal.close();
        };
    }]);
}());